import { __assign, __rest } from "tslib";
import * as React from 'react';
import { DateField } from '../DateField';
import { TimeField } from '../TimeField';
import { oneDay } from '../TimeField/internal/common';
function getDate(value) {
    if (typeof value === 'number' || typeof value === 'string') {
        return new Date(value);
    }
    else if (value instanceof Date) {
        return value;
    }
    else {
        return new Date();
    }
}
function getTime(value) {
    if (value instanceof Date) {
        var v = value.getTime();
        return v % oneDay;
    }
    return 0;
}
export var DateTimeField = function (_a) {
    var value = _a.value, defaultValue = _a.defaultValue, minDateTime = _a.minDateTime, maxDateTime = _a.maxDateTime, label = _a.label, onChange = _a.onChange, children = _a.children, props = __rest(_a, ["value", "defaultValue", "minDateTime", "maxDateTime", "label", "onChange", "children"]);
    var controlled = React.useMemo(function () { return value !== undefined; }, []);
    var _b = React.useState(getDate(controlled ? value : defaultValue)), val = _b[0], setVal = _b[1];
    React.useEffect(function () {
        if (controlled) {
            setVal(getDate(value));
        }
    }, [value]);
    var change = function (date) {
        if (date !== val) {
            if (!controlled) {
                setVal(date);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(date);
        }
    };
    var changeDate = function (date) {
        if (date !== undefined) {
            var t = getTime(val);
            var o = getTime(date);
            date.setTime(date.getTime() - o + t);
            change(date);
        }
    };
    var changeTime = function (time) {
        if (time !== undefined) {
            var date = new Date(val);
            var o = getTime(val);
            date.setTime(date.getTime() - o + time);
            change(date);
        }
    };
    return (React.createElement("div", { className: "date-time-group" },
        React.createElement(DateField, __assign({ value: val, onChange: changeDate, minDate: minDateTime, maxDate: maxDateTime, label: label || undefined }, props), children),
        React.createElement(TimeField, __assign({ value: val, onChange: changeTime, minTime: minDateTime, maxTime: maxDateTime, label: label ? ' ' : undefined }, props))));
};
//# sourceMappingURL=index.js.map